import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
const PaymentMngPage = () => {
    return (
        <Box>
            <Outlet />
        </Box>
    );
};

export default PaymentMngPage;
